/**
 * The app's listing badge slugs (`ListingBadge` in the Flutter app). "Highly Recommended" is
 * the app's Guest Favourite; the backend renamed its slug from `guest_favourite`, which is
 * still accepted so an older payload keeps its styling.
 */
const HIGHLY_RECOMMENDED_SLUGS = ["highly_recommended", "guest_favourite"];
const MOST_POPULAR_SLUG = "most_popular";

/** What sits before a badge's name: the API's icon, the app's emoji fallback, or nothing. */
export type BadgeLeading =
  { kind: "image"; src: string } | { kind: "emoji"; emoji: string } | null;

interface IBadgeIconSource {
  slug?: string | null;
  icon?: string | null;
}

export const listingBadgeService = {
  /** The Highly Recommended (Guest Favourite) badge: black pill, laurels on the details page. */
  isHighlyRecommended(slug: string | null | undefined): boolean {
    return !!slug && HIGHLY_RECOMMENDED_SLUGS.includes(slug);
  },

  isMostPopular(slug: string | null | undefined): boolean {
    return slug === MOST_POPULAR_SLUG;
  },

  /**
   * The app's `_badgeLeading` (search_listing_child.dart): the badge's `icon` URL when the
   * API sends one, else 🏆 for Highly Recommended and 🔥 for Most Popular, else nothing.
   */
  leading(badge: IBadgeIconSource | null | undefined): BadgeLeading {
    const icon = badge?.icon?.trim();
    if (icon) return { kind: "image", src: icon };
    if (listingBadgeService.isHighlyRecommended(badge?.slug)) {
      return { kind: "emoji", emoji: "🏆" };
    }
    if (listingBadgeService.isMostPopular(badge?.slug)) {
      return { kind: "emoji", emoji: "🔥" };
    }
    return null;
  },
};
